import React from 'react'
import Header from '../layouts/Header'
import Footer from '../layouts/Footer'
import ProjectStats from '../layouts/ProjectStats'
import Grow from '../layouts/Grow'
import Getintouch from '../layouts/Getintouch'
import TeamSection from '../layouts/TeamSection'
import bgvideo from '../../assets/images/bg-video.mp4'

const About = () => {

    const teamMembers = [
        {
            name: "Dhrumil Rajpara",
            role: "Frontend Developer",
            image: "dhrumil.png",
        },
        {
            name: "Ashok Solanki",
            role: "Backend Developer",
            image: "ashok.png",
        },
        {
            name: "Heet Danidhariya",
            role: "App Developer",
            image: "heet.png",
        },
        {
            name: "Mittal Khimsuriya",
            role: "UI / UX Designer",
            image: "mittal.png",
        },
        {
            name: "Janvi Parmar",
            role: "Frontend Developer",
            image: "janvi.png",
        },
        {
            name: "Sneh Gohil",
            role: "React Developer",
            image: "sneh.png",
        },
    ];
    return (
        <div>
            <Header />
            <section className="about">
                <video
                    className="bg-video"
                    autoPlay
                    loop
                    muted
                    poster="../../assets/images/bg-video.mp4"
                >
                    <source src={bgvideo} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>

                <div className="banner-contant">
                    <h2>Our Company</h2>
                    <h5 className="banner-h5">
                        Code Buddy's is your trusted <span>IT partner</span>, providing expert web, app,
                        and digital marketing solutions to help your business <span>grow</span> and <span>succeed.</span>
                    </h5>
                </div>
            </section>

            <div className="main-container">
                <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
                    The Numbers of Success
                </h2>
                <ProjectStats />
                <p style={{ textAlign: "center" }}>Driven by Results. Proven by Numbers.</p>
            </div>

            {/* <section>
                <div class="text-area">
                    <h2 style={{ marginBottom: '10px' }}>The Minds Behind the Tech </h2>
                    <p>Behind every smart solution is a smarter team —
                        and here they are</p>
                </div>

            </section> */}
            <TeamSection />

            {/* team member  */}

            {/* <section>
                <div className="team-member">
                    <h2 className="team-text">Meet the Team</h2>
                    <div className="team-grid">
                        {teamMembers.map((member, index) => (
                            <div className="team-grid-card" key={index}>
                                <img
                                    src={require(`../../assets/images/${member.image}`)}
                                    alt={member.name}
                                />
                                <h3 className="team-grid-h3">{member.name}</h3>
                                <p className="team-grid-p">{member.role}</p>
                            </div>
                        ))}
                    </div>
                    <h2 className="team-text1">
                        Behind every great solution is a brilliant team.
                        <br />
                        Here they are
                    </h2>
                </div>
            </section> */}

        
            <Grow />
            <Getintouch />
            <Footer />
        </div>
    )
}

export default About